import React from "react";

import { BadgeComponentProps } from "./badge.props";
import { badge } from "./badge.style";

const Badge = <T extends React.ElementType = "span">({
    className,
    inverse,
    size,
    tag,
    ...attributes
}: BadgeComponentProps<T>) => {
    const Tag = tag || ("span" as React.ElementType);

    return (
        <Tag
            {...attributes}
            className={badge({ inverse, size, className })}
        />
    );
};

export { Badge };
